<template>
  <div class="admin__filter" v-if="value.length">
    <div class="row">
      <div v-for="(param, index) in value" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3">
          <div class="form-group">
            <label :for="'filter-param-' + index" class="text-muted small">{{param.name}}</label>
            <input
              v-if="param.type === 'text'"
              type="text"
              :value="param.value"
              class="form-control"
              :id="'filter-param-' + index"
              :placeholder="param.name"
              @input="updateParams($event, param, index)"
            >
            <vue-multiselect
              v-if="param.type === 'select'"
              :options="param.options"
              :multiple="param.multiple"
              :searchable="true"
              :allow-empty="true"
              :value="getSelectedMultiselectByValue(param.value, param.options, 'value')"
              placeholder="Выбрать"
              selectedLabel="Выбрано"
              deselectLabel="Нажимите для удаления"
              selectLabel="Нажимите для выбора"
              track-by="value"
              label="name"
              @input="updateParams($event, param, index)"
            />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueMultiselect from 'vue-multiselect/src/Multiselect'
  import replaceAnchorParams from 'helpers/replaceAnchorParams'
  import indexOfProperty from 'helpers/indexOfProperty'
  export default {
    name: 'AdminFilter',
    components: {VueMultiselect},
    props: {
      value: {
        type: Array,
        required: true
      }
    },
    watch: {
      '$route' (to, from) {
        this.anchorFilter()
      }
    },
    methods: {
      anchorFilter () {
        let url = decodeURI(window.location.href).split('#')
        let newParams = this.value
        if (url[1]) {
          let params = url[1].split('&')
          params.forEach(item => {
            let value = item.split('=')
            this.value.forEach((param, index) => {
              if (value[0] === 'filter-' + param.code) {
                newParams[index].value = value[1]
              }
            })
          })
        }
        this.$emit('input', newParams)
      },
      updateParams (event, param, index) {
        let params = this.value
        if (param.type === 'text') {
          params[index].value = encodeURIComponent(event.target.value)
        }
        if (param.type === 'select') {
          params[index].value = event.value
        }
        window.location.href = replaceAnchorParams(window.location.href, 'filter-' + params[index].code, params[index].value)
        this.$emit('input', params)
      },
      getSelectedMultiselectByValue (value, options, property) {
        let index = indexOfProperty(options, property, value)
        if (index > -1) {
          return options[index]
        }
        return null
      }
    },
    created () {
      this.anchorFilter()
    }
  }
</script>

<style scoped lang="scss">
    .admin__filter{
      background: #fff;
      padding: 20px;
      padding-bottom: 0;
      -webkit-border-top-left-radius: 3px;
      -webkit-border-top-right-radius: 3px;
      -moz-border-radius-topleft: 3px;
      -moz-border-radius-topright: 3px;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
</style>



// WEBPACK FOOTER //
// AdminFilter.vue?b77202aa